export default __webpack_public_path__ + "static/media/FontsFree-Net-Proxima-Nova-Sbold.22781785.otf";